export interface LeaseTabConfig {
  key: string;
  label: string;
  /** Solo se renderiza si el lease NO está en estado 'Pendiente' (tabs post-originación). */
  conditional: boolean;
  /** Si se define, la pestaña solo es visible para roles con este [módulo, permiso]. */
  permission?: [string, string];
}

export const LEASE_TABS_CONFIG: LeaseTabConfig[] = [
  { key: 'cliente', label: 'Cliente', conditional: false },
  { key: 'activos', label: 'Activos', conditional: false },
  { key: 'cotizaciones', label: 'Cotizaciones', conditional: false },
  { key: 'documentos', label: 'Documentos', conditional: false },
  { key: 'algoritmo', label: 'Algoritmo', conditional: false },
  { key: 'dictamen-legal', label: 'Dictamen Legal', conditional: false },
  { key: 'analisis-riesgo', label: 'Análisis de riesgo', conditional: false },
  { key: 'comite', label: 'Comité', conditional: false, permission: ['committee', 'view'] },
  { key: 'negociacion', label: 'Negociación', conditional: false },
  { key: 'circulo-credito', label: 'Círculo de Crédito', conditional: false },
  { key: 'contrato', label: 'Contrato', conditional: false },
  { key: 'facturacion', label: 'Facturación', conditional: false, permission: ['billing', 'view'] },
  { key: 'pago-inicial', label: 'Pago inicial', conditional: false },
  { key: 'adquisicion-activo', label: 'Adquisición de activo', conditional: true },
  { key: 'entrega', label: 'Entrega', conditional: true },
  { key: 'cobranza', label: 'Cobranza', conditional: true },
  { key: 'exigibilidad', label: 'Exigibilidad', conditional: true, permission: ['payments', 'get-all'] },
  { key: 'bitacora', label: 'Bitácora', conditional: true }
];
